/* eslint-disable indent */
import moment from 'moment-timezone';
import { jwtDecode } from 'jwt-decode';
import { MAX_COOKIES_AGE, ADMIN_TOKEN_COOKIE_NAME, ADMIN_REFRESH_TOKEN_COOKIE_NAME } from '../constants';

export const decodeHtml = (encoded) => {
  if (!encoded || typeof encoded !== 'string') return encoded ?? '';
  if (typeof document === 'undefined') return encoded;
  const textarea = document.createElement('textarea');
  textarea.innerHTML = encoded;
  return textarea.value;
};

export const formatCurrency = (value) => {
  if (value) {
    let val = value;
    val = val ? parseFloat(val).toFixed(2) : 0.00;
    return val === 0 ? '₦0.00' : `₦${Number(val).toLocaleString('en-US')}`;
  }
  return '₦0.00';
};

export const concealEmail = (email = '') => email.replace(/(?!^).(?=[^@]+@)/g, '*');

export const concealValue = (value = '') => (value ? value.replace(/\w/g, '*') : '');

export const logger = (...logs) => (process.env.NODE_ENV === 'development' ? console.log(...logs, `(Log time - ${moment().format('LLL')})`) : undefined);

export const format2Digits = (num) => {
  if (typeof num !== 'number' || Number.isNaN(num)) return 0;

  return num.toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false }) || 0;
};

export const formatFileUrl = (path) => {
  if (path) return `${process.env.REACT_APP_API_BASE_URL}/${path}`;
  return null;
};

export const toggleScroll = () => {
  const overlays = document.querySelectorAll('.overlay');

  if (overlays.length > 0) {
    document.body.classList.add('no-scroll');
  } else {
    document.body.classList.remove('no-scroll');
  }
};

export const formatStatus = (status) => {
  switch (status) {
    case 'pending': return 'Pending';
    case 'parked': return 'Parked';
    case 'valid': return 'Valid';
    case 'approved': return 'Approved';
    case 'referred': return 'Referred';
    case 'rejected': return 'Rejected';
    case 'in-review': return 'In Review';
    case 'in-progress': return 'In Progress';
    case 'implemented': return 'Implemented';

    case 'open': return 'Open';
    case 'closed': return 'Closed';

    case 'published': return 'Published';
    case 'unpublished': return 'Not Published';

    default: return status;
  }
};

export const Logger = (...logs) => (process.env.NODE_ENV === 'development'
  ? console.log(...logs, `(Log time - ${new Date().toLocaleString()})`) // eslint-disable-line no-console
  : undefined);

export const getCookie = (name) => {
  try {
    const value = typeof window !== 'undefined' ? `; ${document.cookie}` : '';
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) {
      const part = parts.pop()?.split(';').shift();
      return part ? decodeURIComponent(part) : null;
    }
    return null;
  } catch (error) {
    Logger('getCookie error', error);
    return null;
  }
};

export const setCookie = (cname, cvalue, age) => {
  if (typeof window !== 'undefined') {
    document.cookie = `${cname}=${encodeURIComponent(cvalue)};max-age=${age || MAX_COOKIES_AGE};Secure;SameSite=Strict;path=/`;
  }
};

export const expireCookie = (cname) => {
  if (typeof window !== 'undefined') {
    document.cookie = `${cname}=;max-age=0;Secure;SameSite=Strict;path=/`;
  }
};

export const handleLogoutRedirect = () => {
  if (typeof window !== 'undefined') {
    expireCookie('_tk');
    expireCookie('_rtk');
    expireCookie('_rtk_exp');
    window.location.replace('/sign-in');
  }
};

export const handleAdminLogoutRedirect = () => {
  if (typeof window !== 'undefined') {
    expireCookie(ADMIN_TOKEN_COOKIE_NAME);
    expireCookie(ADMIN_REFRESH_TOKEN_COOKIE_NAME);
    window.location.replace('/admin-portal/login');
  }
};

export const getErrorMessage = (error) => (
  error?.response?.data?.title
  || (typeof error?.response?.data === 'string'
    ? error?.response?.data || error?.response?.statusText
    : error?.response?.data?.message)
  || (Array.isArray(error?.data?.errors)
    ? error.data.errors
      .map((e) => e?.message)
      .filter(Boolean)
      .join(', ')
    : null)
  || (Array.isArray(error?.data)
    ? error.data
      .map((e) => e)
      .filter(Boolean)
      .join(', ')
    : null)
  || error?.data?.message
  || error?.data?.responseMessage
  || error?.message
  || 'An unknown error occurred'
);

const CLAIM_NAME = 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name';

export const decodeJwt = (token = '') => {
  try {
    if (!token) return null;
    const d = jwtDecode(token);

    const tokenData = {
      fullName: d?.fullName || d?.[CLAIM_NAME] || '',
      staffId: d?.staffId || '',
      branchId: d?.branchId || '',
      branchName: d?.branchName || '',
      department: d?.department || '',
      Email: d?.Email || d?.email || '',
      lineManagerName: d?.lineManagerName || '',
      lineManagerEmail: d?.lineManagerEmail || '',
      exp: d?.exp,
      iss: d?.iss,
      aud: d?.aud
    };

    return tokenData;
  } catch (error) {
    Logger('decodeJwt error', error);
    return null;
  }
};
